import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';

import { SharedModule } from '@app/shared';
import { InvoicesRoutingModule } from './invoices-routing.module';
import { InvoicesComponent } from './invoices.component';
import { TranslateModule } from '@ngx-translate/core';
import { ClipboardModule } from 'ngx-clipboard';

@NgModule({
  declarations: [InvoicesComponent],
  imports: [CommonModule, RouterModule, SharedModule, InvoicesRoutingModule, TranslateModule, ClipboardModule],
  exports: [InvoicesComponent]
})
export class InvoicesModule {}
